<template>
    <div @mouseover="ddopen = true" @mouseout="ddopen = false">
        <div v-if="leads.length > 0">
            <a class="button is-info is-outlined incomplete-lead" >
                &nbsp;Pedidos iniciados ({{leads.length}})&nbsp;
            </a>
        </div>
        <transition name="slide-fade">
            <div v-if="ddopen === true" class="input-expanded" >
                <div class="expanded-line" v-for="(l, index) in leads" :key="index" style="display:flex; justify-content: space-between; align-items: center;">
                    <p @click="setLead(l)">{{l.service.title}} </p>
                    <i class="fa fa-close mr20 delicon" @click="removeLead(index)"></i>
                </div>
            </div>
        </transition>
        <app-modal-order :savedLead="lead" :helpers="helpers" :orderModal="orderModal" @closeOrderModal="orderModal = null" :service="lead ? lead.service : null"/>

    </div>
</template>
<script>
import AppModalOrder from "./ModalOrder";
//import {all} from '../plugins/serviceList'
import helpers from "../plugins/helpers";

export default {
  components: { AppModalOrder },
  data() {
    return {
      helpers,
      //services: all,

      service: null,
      lead: null,
      orderModal: false,

      leads: this.$store.state.incompleteLeads.data,
      ddopen: false
    };
  },
  methods: {
    setLead(l) {
      this.ddopen = false;
      setTimeout(() => {
        this.proceed(l);
      }, 500);
    },
    proceed(l) {
      this.lead = l;
      this.orderModal = true;
    },
    removeLead(l) {
      this.ddopen = false;
      this.$store.commit("removeIncompleteLead", l);
    }
  }
};
</script>
<style scoped lang="scss">
$input-width: 15rem;

.incomplete-lead {
  font-size: 1rem;
  padding: 1.2rem 1.2rem;
  font-weight: 700;
  margin-right: 0.75rem;
  background-color: transparent !important;
  z-index: 10;
  width: $input-width;
}
a:hover,
a.is-active {
  background-color: #2d3256 !important;
  color: white !important;
}

$font-size: 1.125rem;
$input-line-height: 3rem;

.input-expanded {
  position: absolute;
  background-color: #ffffff;
  width: 100%;
  color: #2d3256;
  max-width: $input-width;
  max-height: $input-line-height * 0.8 * 5;
  overflow-y: auto;
  z-index: 8;
  border: solid 1px #2d3256;
  border-top: none;
}

.expanded-line {
  position: relative;
  //height:$input-line-height*0.8;
  line-height: $input-line-height * 0.8;
  font-size: $font-size * 0.8;
  display: flex;
  padding-left: 0.75rem;
  border-bottom: solid 1px #f1f1f1;
  cursor: pointer;
  z-index: 9;

  > p {
    width: 100%;
    margin-right: 1rem;
    /* overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;*/
  }
}

.expanded-line:hover {
  color: white !important;
  background-color: #2d3256 !important;
}

.expanded-line:last-child {
  border-bottom: none;
}

.delicon:hover {
  transition: all 0.4s;
  color: #e90054 !important;
  font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// src/components/IncompleteLead.vue